import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * This component will scroll the window to the top whenever
 * the pathname changes (i.e., a navigation occurs)
 */
const ScrollToTopOnNavigate: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Disable browser's automatic scroll restoration to prevent conflicts in SPA navigation
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        // Force an instant jump to the top, overriding any global scroll-behavior: smooth
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto'
        });
    }, [pathname]);

    // This component doesn't render anything
    return null;
};

export default ScrollToTopOnNavigate;
